import { css } from 'styled-components'

import dogLickImg from '@/assets/images/stickers/dog-lick.gif'
import eatPrayMoneyImg from '@/assets/images/stickers/eat-pray-money.gif'
import gifGroupImg from '@/assets/images/stickers/gifgroup.gif'
import skaterImg from '@/assets/images/stickers/skater.gif'
import peeker1Img from '@/assets/images/stickers/01_peeker.gif'
import peeker2Img from '@/assets/images/stickers/02_peeker.gif'
import clipsThumbImg from '@/assets/images/stickers/clips-thumb.gif'
import soundOnImg from '@/assets/images/stickers/sound-on.gif'
import waterfallDarkImg from '@/assets/images/phone-mock/waterfall-dark.gif'
import waterfallLightImg from '@/assets/images/phone-mock/waterfall-light.gif'
import searchImg from '@/assets/images/phone-mock/search.gif'
import contentTypeImg from '@/assets/images/phone-mock/content-types.gif'

export const slideContent = [
  {
    leftHeader: 'Customizable UI',
    leftText:
      'Toggle between different layouts, color themes and display options with the touch of a button. For the first time, no two GIPHY’s are alike.',
    rightHeader: undefined,
    rightText: undefined,
    isToggle: true,
    leftIndex: 1,
    rightIndex: 2,
  },
  {
    leftHeader: 'Exclusive Content',
    leftText:
      'With the SDK in your app, your users get an infinite library of high quality GIFs, Clips & Stickers: All the classics, content \n' +
      'from our top tier partners, GIPHY Artists, GIPHY Originals, and everything else you won’t find anywhere else.',
    rightHeader: 'Sound on for GIPHY Clips',
    rightText:
      'The latest content type to join the SDK offering is GIPHY Clips. Just like GIFs but with sound, these short videos are optimized for conversation and come ready for in-line playback with our new \n' +
      'Video Components.',
    leftIndex: 1,
    rightIndex: 2,
  },
  {
    leftHeader: 'Unmatched Search',
    leftText:
      'A powerful search algorithm developed by our world class engineering team and vetted by the biggest apps is now yours. Deliver the right GIF, at the right time, every time.',
    rightHeader: 'Smart Analytics',
    rightText:
      'What good is the best content without the tools to match? Our analytics learn from user behavior to help us deliver smarter results and boost user engagement.',
    leftIndex: 1,
    rightIndex: 2,
  },
]

export const phoneImages = [
  { dark: waterfallDarkImg, light: waterfallLightImg },
  { src: contentTypeImg },
  { src: searchImg },
] as const

export const slide2Stickers = (showSecondSlideEmojis: boolean) => [
  {
    src: dogLickImg,
    className: css`
      width: 114px;
      top: 55%;
      left: 27.5%;
      transition: transform 200ms ease-in-out;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: eatPrayMoneyImg,
    className: css`
      width: 270px;
      top: 2%;
      left: 99%;
      transition: transform 200ms ease-in-out 0.1s;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: gifGroupImg,
    className: css`
      width: 236px;
      top: -15%;
      left: -15%;
      transition: transform 200ms ease-in-out 0.4s;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: skaterImg,
    className: css`
      width: 230px;
      top: 66%;
      left: -21%;
      transition: transform 200ms ease-in-out 0.6s;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: clipsThumbImg,
    className: css`
      width: 260px;
      top: 56%;
      left: 102%;
      transition: transform 200ms ease-in-out 0.6s;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: soundOnImg,
    className: css`
      width: 85px;
      top: 18%;
      left: 71%;
      transition: transform 200ms ease-in-out 0.2s;
      transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};

      @media (max-width: 962px) {
        top: 8%;
      }
    `,
  },
]

export const slide3Stickers = (showThirdSlideEmojis: boolean) => [
  {
    src: peeker1Img,
    className: css`
      width: 230px;
      top: -14.6%;
      left: 0%;
      transition: transform 200ms ease-in-out 0.1s;
      transform: ${showThirdSlideEmojis ? 'scale(1)' : ''};
    `,
  },
  {
    src: peeker2Img,
    className: css`
      width: 230px;
      top: 80.9%;
      right: 0%;
      transition: transform 200ms ease-in-out 0.2s;
      transform: ${showThirdSlideEmojis ? 'scale(1)' : ''};
    `,
  },
]
